import React from 'react';

function NavIcon({ id, active, size = 18 }) {
  const c = active ? 'var(--navy)' : 'var(--slate)';
  const s = { width: size, height: size };
  if (id === 'logbook') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/>
      <line x1="9" y1="7" x2="16" y2="7"/><line x1="9" y1="11" x2="16" y2="11"/><line x1="9" y1="15" x2="13" y2="15"/>
    </svg>
  );
  if (id === 'maintenance') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
    </svg>
  );
  if (id === 'add') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.9" strokeLinecap="round">
      <circle cx="12" cy="12" r="9"/>
      <line x1="12" y1="8" x2="12" y2="16"/>
      <line x1="8" y1="12" x2="16" y2="12"/>
    </svg>
  );
  if (id === 'stats') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  );
  if (id === 'boat') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 17l9-13 9 13"/><path d="M3 17c0 2.5 18 2.5 18 0"/><line x1="12" y1="4" x2="12" y2="17"/>
    </svg>
  );
  if (id === 'crew') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
    </svg>
  );
  return null;
}

// ── Mobile bottom-nav icon set (navy-on-light frosted bar) ──
function MobileNavIcon({ id, active, size = 22 }) {
  const c = active ? 'var(--navy)' : 'var(--slate)';
  const s = { width: size, height: size };
  if (id === 'logbook') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/>
      <line x1="9" y1="7" x2="16" y2="7"/><line x1="9" y1="11" x2="16" y2="11"/><line x1="9" y1="15" x2="13" y2="15"/>
    </svg>
  );
  if (id === 'maintenance') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
    </svg>
  );
  if (id === 'add') return (
    <svg style={{ width: size + 4, height: size + 4 }} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" fill={active ? 'var(--gold)' : 'rgba(255,255,255,0.15)'} stroke={active ? 'var(--gold)' : 'rgba(255,255,255,0.3)'} strokeWidth="1.5"/>
      <line x1="12" y1="7" x2="12" y2="17" stroke={active ? 'var(--navy)' : 'rgba(255,255,255,0.8)'} strokeWidth="2" strokeLinecap="round"/>
      <line x1="7" y1="12" x2="17" y2="12" stroke={active ? 'var(--navy)' : 'rgba(255,255,255,0.8)'} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  if (id === 'stats') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  );
  if (id === 'boat') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 17l9-13 9 13"/><path d="M3 17c0 2.5 18 2.5 18 0"/><line x1="12" y1="4" x2="12" y2="17"/>
    </svg>
  );
  if (id === 'crew') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
    </svg>
  );
  return null;
}

const TABS = [
  { id: 'logbook',     label: 'Logbook' },
  { id: 'maintenance', label: 'Service' },
  { id: 'add',         label: 'Add', isAction: true },
  { id: 'stats',       label: 'Stats' },
  { id: 'boat',        label: 'Boat' },
];

export default function NavBar({ active, onSelect, width = 900 }) {
  const isMobile = window.innerWidth < 768;

  if (!isMobile) {
    // ── DESKTOP — W4 pattern: cream tabs bar, sticky to top of viewport,
    //    gold underline on active tab, sits directly under the masthead
    //    and pins there once you scroll past it. ──
    return (
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'rgba(244,241,234,0.82)', backdropFilter:'blur(10px)', WebkitBackdropFilter:'blur(10px)',
        borderBottom: '1px solid var(--border)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
      }}>
        <div style={{
          maxWidth: width,
          margin: '0 auto',
          display: 'flex',
        }}>
          {TABS.map(t => (
            <button
              key={t.id}
              onClick={() => onSelect(t.id)}
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 7,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: 14,
                fontWeight: active === t.id ? 700 : 600,
                color: active === t.id ? 'var(--navy)' : 'var(--slate)',
                padding: '14px 8px',
                border: 'none',
                background: 'none',
                borderBottom: active === t.id ? '2px solid var(--gold-lt)' : '2px solid transparent',
                cursor: 'pointer',
                transition: 'color 0.18s, border-color 0.18s',
                whiteSpace: 'nowrap',
              }}
              onMouseEnter={e => { if (active !== t.id) e.currentTarget.style.color = 'var(--ink)'; }}
              onMouseLeave={e => { if (active !== t.id) e.currentTarget.style.color = 'var(--slate)'; }}
            >
              <span style={{ lineHeight: 0, opacity: active === t.id ? 1 : 0.7 }}>
                <NavIcon id={t.id} active={active === t.id} size={17}/>
              </span>
              {t.isAction ? 'Add' : t.label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  // ── MOBILE: floating pill nav (matches race app) ──
  return (
    <nav style={{
      position: 'fixed',
      bottom: 14,
      left: 14,
      right: 14,
      zIndex: 200,
      background: 'rgba(255,255,255,0.72)',
      backdropFilter: 'blur(16px) saturate(1.3)',
      WebkitBackdropFilter: 'blur(16px) saturate(1.3)',
      border: '1px solid rgba(213,204,186,0.7)',
      borderRadius: 24,
      display: 'flex',
      alignItems: 'stretch',
      padding: '10px 10px',
      boxShadow: '0 6px 22px rgba(11,22,38,0.14)',
      marginBottom: 'env(safe-area-inset-bottom)',
    }}>
      {TABS.map(t => (
        <button
          key={t.id}
          onClick={() => onSelect(t.id)}
          aria-label={t.label}
          style={{
            flex: t.isAction ? '0 0 58px' : 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            padding: '4px 0',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            position: 'relative',
          }}
        >
          {t.isAction ? (
            <span style={{
              width: 46, height: 46, borderRadius: '50%', background: 'var(--navy)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 6px 16px rgba(11,22,38,0.32)', marginTop: -18,
              border: '3px solid rgba(255,255,255,0.9)',
            }}>
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round">
                <line x1="12" y1="6" x2="12" y2="18"/><line x1="6" y1="12" x2="18" y2="12"/>
              </svg>
            </span>
          ) : (
            <>
              <MobileNavIcon id={t.id} active={active === t.id} size={20}/>
              <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:9, fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color: active === t.id ? 'var(--navy)' : 'var(--slate)', lineHeight:1 }}>
                {t.label}
              </span>
            </>
          )}
        </button>
      ))}
    </nav>
  );
}
